<template>
    <div class="page-wrapper bg-white radius-lg margin-left-sm">
        <div class="tabs-container flex align-center">
            <div v-for="(item,index) in menus" :key="index"
                 :class="[{active:curTab === item.value}]" class="tab" @click="menuChange(item.value)">{{ item.label }}
            </div>
        </div>
        <div class="page-list flex flex-direction padding flex-sub">
            <el-table
                v-loading="loading"
                :data="lists"
                border
                header-row-class-name="table-header"
                style="width: 100%">
                <el-table-column label="任务名称" prop="name">
                    <template slot-scope="scope">
                        <div class="cursor" @click="finishTask(scope.row)">
                            {{ scope.row.name }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="优先级" prop="level" width="170">
                    <template slot-scope="scope">
                        <div class="table-item">
                            <el-tag :type="scope.row.level | level_color" class=" radius">{{ scope.row.level | level
                                }}
                            </el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column  label="分值" prop="p_mid" width="170">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.score || '0' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="负责人" prop="p_mid" width="170">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.member_name || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="完成时间" prop="end_time" width="170">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.end_time }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                class="page-all margin-top self-end"
                layout="prev, pager, next"
                @current-change="init">
            </el-pagination>
        </div>
        <task-finish-dialog :dialog-visible="finishTaskDialog" :tid="cur_task_id"  @watchState="watchState"></task-finish-dialog>
        <task-detail-task-dialog :dialog-visible="addTaskDetailDialog" :readonly="true" :tid="cur_task_id" @watchDetailState="watchDetailState"></task-detail-task-dialog>
    </div>
</template>

<script>

import {level_color, levels, task_menus} from "@/utils/const";
import {myTaskList} from "@/api";
import TaskFinishDialog from "@/views/web/staff/components/TaskFinishDialog";
import TaskDetailTaskDialog from "@/views/web/staff/components/TaskDetailTaskDialog";

export default {
    name: "task-mine",
    components: {TaskDetailTaskDialog, TaskFinishDialog},
    data() {
        return {
            menus: task_menus,
            curTab: 2,
            lists: [],
            page: 1,
            limit: 10,
            total: 0,
            loading: false,
            cur_task_id:0,
            finishTaskDialog:false,
            addTaskDetailDialog:false,
        }
    },
    created() {
        this.$emit('setIndex', [2,1], '我的任务', false)
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async init() {
            this.loading = true
            let _data = await myTaskList(this.curTab,this.page,this.limit)
            this.lists = _data.data.data
            this.total = _data.data.total
            this.loading = false
        },
        menuChange(value) {
            this.curTab = value
            this.page = 1
            this.init()
        },
        finishTask(data){
            this.cur_task_id = data.id
            if (this.curTab === 7 ){
                this.addTaskDetailDialog = true
            } else {
                this.finishTaskDialog = true
            }
        },
        watchState(data) {
            if (data) this.init()
            this.cur_task_id = 0
            this.finishTaskDialog = false
            this.addTaskDetailDialog = false
        },
        watchDetailState(data) {
            if (data) {
                this.init()
            } else {
                this.cur_task_id = 0
                this.addTaskDetailDialog = false;
            }
        }
    },
    filters:{
        level(val) {
            return levels.find(f => Number(f.value) === val).label
        },
        level_color(val) {
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            return level_color(val)
        }
    }

}
</script>

<style lang="scss" scoped>
.page-wrapper {
}
</style>
